import { render, staticRenderFns } from "./news_work.vue?vue&type=template&id=4c21503c&scoped=true"
import script from "./news_work.vue?vue&type=script&lang=js"
export * from "./news_work.vue?vue&type=script&lang=js"
import style0 from "./news_work.vue?vue&type=style&index=0&id=4c21503c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c21503c",
  null
  
)

export default component.exports